import api from "./Api";

class EmitenteService {
  GetEmitente(payload) {
    return api.get("/v1/emitente/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEmitente(payload) {
    return api.post("/v1/emitente/", payload).then((response) => {
      return response.data;
    });
  }

  PutEmitente(payload) {
    return api.put("/v1/emitente/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEmitente(payload) {
    return api.delete("/v1/emitente/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEmitenteOData(payload) {
    return api.get("/OData/Emitente" + payload).then((response) => {
      return response.data;
    });
  }

  PostRegisterEmitente(payload) {
    return api.post("/v1/registerEmitente/", payload).then((response) => {
      return response.data;
    });
  }
}

export default new EmitenteService();
